/*
 * @Author: keman.chen
 * @Date: 2023-08-25 11:35:51
 * @LastEditTime: 2024-01-04 19:13:51
 * @LastEditors: keman.chen
 * @Description: 
 * @FilePath: /tlog-dashboard/Users/keman.chen/code/monitor/packages/types/src/transportData.ts
 */
import { BreadcrumbPushData } from './breadcrumb'
import { EActionType } from './track'
import { DeviceInfo } from './common'

export interface AuthInfo {
  app_id?: string
  trackKey?: string
  sdkVersion: string
  sdkName: string
  trackerId: string
}

export interface TransportDataType {
  authInfo: AuthInfo
  breadcrumb?: BreadcrumbPushData[]
  data?: FinalReportType
  record?: any[]
  deviceInfo?: DeviceInfo
}

export type FinalReportType = ReportDataType | TrackReportData

interface ICommonDataType {
  // 是否是埋点数据
  isTrackData?: boolean
}

export interface ReportDataType extends ICommonDataType {
  type?: string
  message?: string
  url: string
  name?: string
  stack?: any
  time?: number
  sTime?: number
  eTime?: number
  errorId?: number
  level: string
  elapsedTime?: number
  duration?: number
  traceId?: string
  method?: string
  reqUrl?: string
  reqData?: any
  status?: number
  response?: string
  // vue
  componentName?: string
  propsData?: any
  // logError 手动报错 MITO.log
  customTag?: string
}

export interface TrackReportData extends ICommonDataType {
  // uuid
  id?: string
  // 埋点code 一般由人为传进来，可以自定义规范
  trackId?: string
  // 埋点类型
  actionType: EActionType
  // 埋点开始时间
  startTime?: number
  // 埋点停留时间
  durationTime?: number
  // 上报时间
  trackTime?: number
}

export function isReportDataType(data: ReportDataType | TrackReportData): data is ReportDataType {
  return (<TrackReportData>data).actionType === undefined && !data.isTrackData
}

export interface LogType {
  user: string
  type: string
  level: string
  attributes: ReportDataType;
  timestamp: number
}

export interface ReportResourceType extends DeviceInfo {
  app_id: string
  uuid: string
  url: string
  s_v: string
  s_n: string
  lang: string
  tz: string
  refer: string
  uts: number
}

export interface FinalReportModel {
  logs: Array<LogType>
  resource: ReportResourceType,
  env: string,
  user: string
}